module.exports = __webpack_public_path__ + "img/alfredo.28f778d5.png";